<template>
  <section class="tf-card">
    <div class="tf-card__head">
      <span class="tf-card__icon"><i class="fa fa-file-o"></i></span>
      <div class="tf-card__titles">
        <h3 class="tf-card__title">Страницы</h3>
        <p class="tf-card__sub">
          Время у 75% посетителей и изменение к прошлому периоду той же длины.
          Всего просмотров: {{ formatCount(data.totalViews) }}
        </p>
      </div>
    </div>
    <div class="tf-card__body">
      <div v-if="!rows.length" class="an-empty">
        <i class="fa fa-file-o"></i>
        <span>За период просмотров не было</span>
      </div>
      <RumMetricsTable v-else :rows="rows" name-title="Страница"/>
    </div>
  </section>
</template>

<script>
import RumMetricsTable from "./RumMetricsTable.vue";
import {formatCount} from "@/common/rumFormat";

export default {
  name: "RumPages",
  components: {RumMetricsTable},
  props: {
    data: {type: Object, required: true},
  },
  computed: {
    rows() {
      return (this.data.rows || []).map(row => ({...row, key: row.route, sub: row.route}))
    },
  },
  methods: {formatCount},
}
</script>
